import { Typography } from '@mui/material';
import React from 'react';
import LineChartComponent, { DataPoint } from './LineChart.tsx';

type MarketSummaryPerYear = {
  numberOfBusinesses: number;
  totalSalesPerYear: number;
};

const RowComponent = (props: any) => {
  const { label, value } = props;

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        paddingBottom: '5px',
      }}
    >
      <Typography variant="body1">
        <b>{label}:</b>
      </Typography>
      <Typography variant="body1">{value}</Typography>
    </div>
  );
};

const MarketSummary = ({ data, uf }: any) => {
  const typedData = data as Record<number, MarketSummaryPerYear>;

  const lastYear = Object.keys(typedData)
    .map(Number)
    .reduce((max, year) => (year > max ? year : max), -Infinity);

  const lastYearMarketSummary = typedData[lastYear];

  const chartData: DataPoint[] = [];

  for (const [key, value] of Object.entries(typedData)) {
    chartData.push({ year: +key, totalSales: value.totalSalesPerYear * uf });
  }

  let annualGrowth = 0;

  if (Object.keys(typedData).length > 1) {
    annualGrowth =
      (100 *
        (typedData[lastYear].totalSalesPerYear -
          typedData[lastYear - 1].totalSalesPerYear)) /
      typedData[lastYear].totalSalesPerYear;
  }

  const marketTendency = annualGrowth > 0 ? 'Al alza' : 'A la baja';

  return (
    <>
      <Typography fontWeight={600} variant="h6">
        Panorama del segmento económico
      </Typography>
      <div
        style={{
          display: 'flex',
          alignItems: 'flex-start',
          gap: '2rem',
          padding: '1rem',
        }}
      >
        <div
          style={{
            width: '30%',
            padding: '10px',
          }}
        >
          <RowComponent label={'Último año evaluado'} value={lastYear} />
          <RowComponent
            label={'Número de empresas'}
            value={lastYearMarketSummary.numberOfBusinesses}
          />
          <RowComponent
            label={'Crecimiento anual'}
            value={`${Number(annualGrowth).toFixed(2)} %`}
          />
          <RowComponent label={'Tendencia'} value={marketTendency} />
        </div>
        <div style={{ width: '70%' }}>
          <LineChartComponent data={chartData} />
        </div>
      </div>
    </>
  );
};

export default MarketSummary;
